// TOP LEVEL IMPORTS
import React from 'react';
// ANTD
import Card from 'antd/lib/card';
import Icon from 'antd/lib/icon';

const PaypalTip = () => {
  const urls = {
    paypalBrowsers: 'https://www.paypal.com/be/smarthelp/article/how-do-i-check-and-update-my-web-browser-faq3893',
    safeBrowsers: 'https://www.paypal.com/in/webapps/mpp/security/general-saferbrowsers',
  };

  const Title = () => (
    <div>
      <h2>
        <Icon type="exclamation-circle" style={{ color: '#f1c40f', marginRight: 8 }} />
        Having PayPal Issues?
      </h2>
    </div>
  );
  return (
    <Card
      title={<Title />}
      style={{
        alignSelf: 'center',
        margin: '15 auto',
        width: 500,
        maxWidth: '100%',
      }}
    >
      <div style={{ background: '#fff', textAlign: 'left' }}>
        {/* <h3>Having PayPal Issues?</h3> */}
        <p>
          {' '}
          Please be aware that PayPal only supports certain browsers, <br />
          and even then PayPal may not support the version you're on.
        </p>
        <p>
          To check if you're browser works for paypal and learn more about potential browser <br />
          issues, see{' '}
          <a target="_blank" href={urls.paypalBrowsers}>
            this page from the paypal
          </a>{' '}
          (and{' '}
          <a target="_blank" href={urls.safeBrowsers}>
            this one
          </a>{' '}
          too) .
        </p>
      </div>
    </Card>
  );
};

export default PaypalTip;



// WEBPACK FOOTER //
// ./src/components/common/PaypalTip/index.js